import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface RouteLeaveConfirmationState {
    name: string;
    hasDataChange: Nullable<boolean>;
    isChangeSaved: Nullable<boolean>;
}

export const initialState: RouteLeaveConfirmationState = {
    name: '',
    hasDataChange: null,
    isChangeSaved: null,
};

export const routeLeaveConfirmationSlice = createSlice({
    name: 'routeLeaveConfirmation',
    initialState,
    reducers: (create) => ({
        setRouteLeavePageName: create.reducer((state, { payload }: PayloadAction<string>) => {
            state.name = payload;
            state.isChangeSaved = false;
        }),
        setRouteLeaveHasDataChange: create.reducer((state, { payload }: PayloadAction<boolean>) => {
            state.hasDataChange = payload;
        }),
        setRouteLeaveIsChangeSaved: create.reducer((state, { payload }: PayloadAction<boolean>) => {
            state.isChangeSaved = payload;
        }),
        resetRouteLeaveHasDataChange: create.reducer((state) => {
            Object.keys(state).forEach((key) => {
                state[key] = initialState[key];
            });
        }),
    }),
    selectors: {
        selectRouteLeaveConfirmation: (routeLeaveConfirmation) => routeLeaveConfirmation,
    },
});

export const {
    setRouteLeavePageName,
    setRouteLeaveHasDataChange,
    setRouteLeaveIsChangeSaved,
    resetRouteLeaveHasDataChange,
} = routeLeaveConfirmationSlice.actions;
export const { selectRouteLeaveConfirmation } = routeLeaveConfirmationSlice.selectors;
